import React from "react";
import SysStatsCpuReport from "./Report";
import View from "common/View";
import help from "help/viewSysStatsCpu.md";

const SysStatsCpu = ({returnView = null}) => (
  <View title="CPU" mdHelp={help} returnView={returnView}>
    <SysStatsCpuReport returnView={returnView} />
  </View>
);

export default SysStatsCpu;
